<script>
  import { keyIsExpanded, isMobile } from "../stores/global.js";
  let userClickedKey = false;

  const expandKey = () => {
    keyIsExpanded.set(true);
  };

  const closeKey = () => {
    if (userClickedKey) {
      userClickedKey = false;
    } else {
      keyIsExpanded.set(false);
    }
  };

  const stickyExpandKey = () => {
    keyIsExpanded.set(true);
    userClickedKey = !userClickedKey;
  };
</script>

<span
  on:click={stickyExpandKey}
  on:mouseover={$isMobile ? null : expandKey}
  on:focus={$isMobile ? null : expandKey}
  on:mouseleave={closeKey}
  on:blur={closeKey}
  class="inline-key-hover"><slot /></span
>

<style>
  .inline-key-hover {
    background: #1a1a1b;
    color: white;
    padding: 2px 4px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 200;
  }
</style>
